import { createReducer, on } from '@ngrx/store';
import { PropertyAddress, PropertyInformation } from '../../models';
import * as CalculatorActions from '../actions';

export const APP_FEATURE_KEY = 'app';

export interface AppState {
  isLoading: boolean;
  isLoggedIn: boolean;
  pin: string;
  isLoginLoading: boolean;
  address: PropertyAddress;
  estimatedCost: number;
  monthlyCostInfo: PropertyInformation[];
}

export const initialState: AppState = {
  isLoading: false,
  isLoggedIn: false,
  pin: null,
  isLoginLoading: false,
  address: null,
  estimatedCost: null,
  monthlyCostInfo: [],
};

export const reducer = createReducer(
  initialState,
  on(CalculatorActions.validatePin, (state, { payload }) => ({
    ...state,
    isLoginLoading: true,
    pin: payload.pin,
  })),

  on(CalculatorActions.validatePinSuccess, (state) => ({
    ...state,
    isLoggedIn: true,
    isLoginLoading: false,
  })),

  on(CalculatorActions.validatePinFail, (state) => ({
    ...state,
    isLoggedIn: false,
    isLoginLoading: false,
  })),

  on(CalculatorActions.calculateMonthlyCost, (state, { payload }) => ({
    ...state,
    address: payload.address,
    estimatedCost: payload.estimated_cost,
    isLoading: true,
  })),

  on(
    CalculatorActions.calculateMonthlyCostSuccess,
    (state, { monthlyCostData }) => ({
      ...state,
      isLoading: false,
      monthlyCostInfo: monthlyCostData.monthly_costs,
    })
  ),

  on(CalculatorActions.calculateMonthlyCostFail, (state) => ({
    ...state,
    isLoading: false,
  })),

  on(CalculatorActions.logoutSuccess, (state) => ({
    ...state,
    isLoggedIn: false,
    address: null,
    estimatedCost: null,
    monthlyCostInfo: [],
    pin: null,
  })),

  on(CalculatorActions.checkAnotherProperty, (state) => ({
    ...state,
    address: null,
    estimatedCost: null,
    monthlyCostInfo: [],
  }))
);
